import gql from 'graphql-tag';

export const dokkioObjectFragment = gql`
  fragment dokkioObjectFragment on DokkioObject {
    dokkioClass
    id
    dokkioObjectType
  }
`;
export default dokkioObjectFragment;
